/* global $, Proj */

$(function() {
    'use strict';

    var proj = new Proj();

    proj.AjaxForm();
    proj.Responsive();
    proj.Sliders();
    proj.Goal({
        goals: [
            {
                selector: '.js-goal__link',
                event: 'click',
                handler: function(e) {
                    $(window).trigger('Main:reachGoal', $(this).data());
                }
            }, {
                selector: '.js-goal__form',
                event: 'submit',
                handler: function(e) {
                    $(window).trigger('Main:reachGoal', $(this).data());
                }
            }, {
                selector: window,
                event: 'goal AjaxForm:goal',
                handler: function(e, data) {
                    $(window).trigger('Main:reachGoal', data);
                }
            }
        ]
    });
	if (proj.interfaceName == 'home_page' || proj.interfaceName == 'map') {
	    document.ready = ymaps.ready(function() {
	        proj.showMap();
	    });
	}
    proj.More();
    proj.header();
    proj.Branch();
    proj.Catalog();
    proj.GetProd();
    proj.Product();
    proj.Gallery();
    proj.Select();
    proj.GetProject();
    proj.Menu();
    proj.Tabs();
    proj.LandSliders();
    proj.SmoothScroll();
    proj.Activities();
    proj.ajaxVisSlider();
});
